import { climateAdaptive } from './focusClimate';
import { livingIncome } from './focusLiving';
import { greeningLandscape } from './focusGreening';
import { healthyPlanet } from './focusHealthy';

export const allFocusAreas = [
  climateAdaptive,
  livingIncome,
  greeningLandscape,
  healthyPlanet,
];

export function getFocusById(id) {
  return allFocusAreas.find((f) => f.id === id);
}
